import {Component, OnInit} from "@angular/core";

import * as AOS from "aos";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  selector: "app-shell",
  templateUrl: "./shell.component.html",
  styleUrls: ["./shell.component.scss"]
})
export class ShellComponent implements OnInit {
  public mobileMenu = false

  openMobile() {
    this.mobileMenu = !this.mobileMenu
  }

  constructor(readonly router: Router) {
      router.events
          .pipe(filter((e) => e instanceof NavigationEnd))
          .subscribe((e) => this.mobileMenu = false)
  }

  ngOnInit() {
    AOS.init()
  }

}
